import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { OperatorDetails } from 'src/app/components/operator/models/OperatorDetails';
import { CityDTO } from 'src/app/components/shared/models/CityDTO';
import { CountyDTO } from 'src/app/components/shared/models/CountyDTO';
import { AddressService } from 'src/app/components/shared/services/address.service';
import { SupplierDetails } from 'src/app/components/supplier/models/SupplierDetails';
import { SupplierService } from 'src/app/components/supplier/services/supplier.service';

@Component({
  selector: 'app-suppliers-details',
  templateUrl: './suppliers-details.component.html',
  styleUrls: ['./suppliers-details.component.scss']
})
export class SuppliersDetailsComponent implements OnInit {

  public supplierDetailsForm: FormGroup;
  public pjIdentificationData: string = "Date identificare PJ";
  public name: string = "Denumire";
  public legalForm: string = "Forma juridica";
  public cui: string = "CUI";
  public onrcRegistrationNumber: string = "Nr. inregistrare la ONRC";
  public phone: string = "Telefon";
  public mobile: string = "Mobil";
  public fax: string = "Fax";
  public email: string = "Email";
  public registeredOfficeAddress: string = "Adresa sediu social";
  public county: string = "Judet";
  public city: string = "Localitate";
  public streetName: string = "Strada";
  public streetNumber: string = "Numar";
  public block: string = "Bloc";
  public floor: string = "Etaj";
  public apartment: string = "Apartament";
  public postalCode: string = "Cod postal";
  public mailingAddress: string = "Adresa corespondenta";
  public sameAddress: string = "Aceeasi cu adresa domiciliu";
  public providerUsers: string = "Utilizatori furnizor";
  public mainAccount: string = "Cont principal";
  public userList = [];
  public supplierId: string;
  public supplier: OperatorDetails;
  public counties: CountyDTO[];
  public cities: CityDTO[];
  public isSameAddress = false;
  public providerUsersSettings = {
    actions: false,
    hideSubHeader: true,
    columns: {
      email: {
        title: 'Adresa de email'
      },
      name: {
        title: 'Nume'
      },
      surname: {
        title: 'Prenume'
      },
      cnp: {
        title: 'CNP'
      },
      accountType: {
        title: 'Tip cont'
      },
    },
    pager: {
      display: true,
      perPage: 5
    }
  };

  constructor(private formBuilder: FormBuilder, private supplierService: SupplierService,
    private addressService: AddressService, private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.supplierId = localStorage.getItem('supplierId');
    this.createSupplierDetailsForm();
  }

  ngOnInit(): void {
    this.addressService.getCounties().subscribe(data => this.counties = data);
    this.supplierService.getSupplierDetailsById(this.supplierId).subscribe(
      (supplier: SupplierDetails) => {
        this.initSupplierDetailsForm(supplier);
        this.userList = new Array<any>({ email: supplier.email, name: supplier.firstName, surname: supplier.lastName, cnp: supplier.cnp, accountType: this.mainAccount });
        this.changeDetectorRef.detectChanges();
      }
    );
  }

  initSupplierDetailsForm(supplier: SupplierDetails) {
    this.supplierDetailsForm.patchValue({
      name: supplier.companyDTO.name,
      legalForm: supplier.companyDTO.legalForm,
      cui: supplier.companyDTO.cui,
      onrcRegistrationNumber: supplier.companyDTO.onrcRegistrationNumber,
      phone: supplier.companyDTO.phoneNumber,
      mobile: supplier.companyDTO.mobileNumber,
      fax: supplier.companyDTO.fax,
      email: supplier.companyDTO.email,
      county: supplier.companyDTO.addressDTO.county,
      city: supplier.companyDTO.addressDTO.city,
      streetName: supplier.companyDTO.addressDTO.streetName,
      streetNumber: supplier.companyDTO.addressDTO.streetNumber,
      block: supplier.companyDTO.addressDTO.block,
      floor: supplier.companyDTO.addressDTO.floor,
      apartment: supplier.companyDTO.addressDTO.apartment,
      postalCode: supplier.companyDTO.addressDTO.postalCode,
      correspondenceCounty: supplier.companyDTO.correspondenceAddressDTO.county,
      correspondenceCity: supplier.companyDTO.correspondenceAddressDTO.city,
      correspondenceStreetName: supplier.companyDTO.correspondenceAddressDTO.streetName,
      correspondenceStreetNumber: supplier.companyDTO.correspondenceAddressDTO.streetNumber,
      correspondenceBlock: supplier.companyDTO.correspondenceAddressDTO.block,
      correspondenceFloor: supplier.companyDTO.correspondenceAddressDTO.floor,
      correspondenceApartment: supplier.companyDTO.correspondenceAddressDTO.apartment,
      correspondencePostalCode: supplier.companyDTO.correspondenceAddressDTO.postalCode
    });
    this.addressService.getCities(this.supplierDetailsForm.get('county').value).subscribe((cities: CityDTO[]) => this.cities = cities);
    this.isSameAddress = JSON.stringify(supplier.companyDTO.addressDTO) === JSON.stringify(supplier.companyDTO.correspondenceAddressDTO);
  }

  createSupplierDetailsForm(): void {
    this.supplierDetailsForm = this.formBuilder.group({
      name: new FormControl({ value: '', disabled: true }),
      legalForm: new FormControl({ value: '', disabled: true }),
      cui: new FormControl({ value: '', disabled: true }),
      onrcRegistrationNumber: new FormControl({ value: '', disabled: true }),
      phone: new FormControl({ value: '', disabled: true }),
      mobile: new FormControl({ value: '', disabled: true }),
      fax: new FormControl({ value: '', disabled: true }),
      email: new FormControl({ value: '', disabled: true }),
      county: new FormControl({ value: '', disabled: true }),
      city: new FormControl({ value: '', disabled: true }),
      streetName: new FormControl({ value: '', disabled: true }),
      streetNumber: new FormControl({ value: '', disabled: true }),
      block: new FormControl({ value: '', disabled: true }),
      floor: new FormControl({ value: '', disabled: true }),
      apartment: new FormControl({ value: '', disabled: true }),
      postalCode: new FormControl({ value: '', disabled: true }),
      correspondenceCounty: new FormControl({ value: '', disabled: true }),
      correspondenceCity: new FormControl({ value: '', disabled: true }),
      correspondenceStreetName: new FormControl({ value: '', disabled: true }),
      correspondenceStreetNumber: new FormControl({ value: '', disabled: true }),
      correspondenceBlock: new FormControl({ value: '', disabled: true }),
      correspondenceFloor: new FormControl({ value: '', disabled: true }),
      correspondenceApartment: new FormControl({ value: '', disabled: true }),
      correspondencePostalCode: new FormControl({ value: '', disabled: true }),
    });
  }
}
